var _path, _path2, _path3, _circle, _circle2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6749 26.6923L22.4071 24.1949C22.5707 24.1088 22.7516 24.0648 22.9363 24.0648C23.5598 24.0648 24.064 24.5658 24.064 25.1854V29.0349C24.064 29.1764 24.0409 29.3199 23.989 29.4518C23.7388 30.0886 22.9979 30.3487 22.4071 30.0389L17.6749 27.5414L12.9427 30.0389C12.3538 30.3506 11.611 30.0886 11.3608 29.4518C11.3089 29.3199 11.2858 29.1783 11.2858 29.0349V25.1854C11.2858 24.5658 11.79 24.0648 12.4135 24.0648C12.5982 24.0648 12.7791 24.1107 12.9427 24.1949L17.6749 26.6923ZM17.6807 32.1577C17.1611 32.1577 16.7416 31.7389 16.7416 31.2245C16.7416 30.7101 17.163 30.2913 17.6807 30.2913C18.1984 30.2913 18.6198 30.7101 18.6198 31.2245C18.6198 31.7389 18.1984 32.1577 17.6807 32.1577Z",
    fill: "#050F4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4905 15.7855V9.96519C24.4905 11.1779 23.1495 12.1473 17.1892 12.1473C12.421 12.1473 11.0303 15.5834 10.9309 17.3015C10.9309 21.0913 12.868 23.2136 17.1892 23.2136C21.5104 23.2136 24.4905 19.4238 24.4905 15.7855Z",
    fill: "#FF5A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87221 12.9811C4.26093 8.13409 11.5662 -0.482737 18.5538 5.87218C23.9533 5.87218 24.4905 8.90006 24.4905 9.96519M24.4905 9.96519V15.7855C24.4905 19.4238 21.5104 23.2136 17.1892 23.2136C12.868 23.2136 10.9309 21.0913 10.9309 17.3015C11.0303 15.5834 12.421 12.1473 17.1892 12.1473C23.1495 12.1473 24.4905 11.1779 24.4905 9.96519Z",
    stroke: "#FF5A5F",
    strokeWidth: 0.851884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5769,
    cy: 15.9784,
    r: 2.56139,
    stroke: "#050F4E",
    strokeWidth: 0.851884
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9793,
    cy: 15.9784,
    r: 2.56139,
    stroke: "#050F4E",
    strokeWidth: 0.851884
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4762 15.4259C18.252 15.3618 18.0215 15.317 17.7782 15.317C17.5349 15.317 17.3043 15.3618 17.0802 15.4259",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4762 15.4259C18.252 15.3618 18.0215 15.317 17.7782 15.317C17.5349 15.317 17.3043 15.3618 17.0802 15.4259",
    stroke: "#050F4E",
    strokeWidth: 0.851884
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3338af281b093f1889db2c3d4a6a919c.svg";
export { ForwardRef as ReactComponent };